export default function FlappyGame() {
  return (
    <iframe
      src="/games/Machine-Learning-Flappy-Bird/source/index.html"
      className="w-full h-screen border-0"
      title="Flappy Bird"
    />
  );
}